export default __webpack_public_path__ + "static/media/slack.4a47068f.png";